<template>
  <EmailPtAccount />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
